import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {CookieService} from 'ngx-cookie-service';
import {SharedService} from '../shared-service';
import {GoldenRulesComponent} from '../../references/golden-rules/golden-rules.component';
import {OrganisationSelectorComponent} from './organisation-selector/organisation-selector.component';
import {ToastrService} from 'ngx-toastr';
import {AuthenticationService} from "../../auth/authentication.service";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  userData = this.sharedService.getUserDataFromSessionStorage();

  goldenRuleDialog: any;

  constructor(public router: Router, public matDialog: MatDialog, private toaster: ToastrService, public activatedRoute: ActivatedRoute, private authService: AuthenticationService,
              public sharedService: SharedService, public cookieService: CookieService, private ref: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.router.events
      .subscribe(() => {
        this.userData = this.sharedService.getUserDataFromSessionStorage();
        if (this.goldenRuleDialog) {
          this.goldenRuleDialog.close();
          this.goldenRuleDialog = null;
        }
      });
    this.getProfileImage();
    this.authService.updateLoggedInUserInfo.subscribe((dataChange) => {
      if (dataChange) {
        this.userData = this.sharedService.getUserDataFromSessionStorage();
        this.getProfileImage();
      }
    })
  }

  getProfileImage() {
    if (!this.userData?.profileImage?.folderName) {
        this.userData.profileImage = { 
            fileUrl: null,
            folderName: null,
            mimeType: null
        };
        sessionStorage.setItem('userInfo', JSON.stringify(this.userData));
        return;
    }

    if (this.userData.profileImage.fileUrl && !this.userData.profileImage.fileUrl.includes('undefined')) {
        return;
    }

    const params = {
        Key: this.userData.profileImage.folderName,
        type: this.userData.profileImage.mimeType 
    };

    this.sharedService.getObjectsFromS3Bucket(params).subscribe({
        next: (res: any) => {
            this.userData.profileImage.fileUrl = res;
            sessionStorage.setItem('userInfo', JSON.stringify(this.userData));
        },
        error: () => {
            this.userData.profileImage.fileUrl = null;
            sessionStorage.setItem('userInfo', JSON.stringify(this.userData));
        }
    });
}
  collapsed = false;
  toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
  }
  // Logout from the current session
  logOut() {
    this.sharedService.logOutCurrentSession().subscribe((res) => {
      this.router.navigate(['/signin']);
      this.cookieService.deleteAll();
      localStorage.clear();
      sessionStorage.clear();
    }, error => {
      this.toaster.error('Something went wrong while logout, Please try again...!');
    });
  }

  logOutAll() {
    this.sharedService.logoutFromAllDevices().subscribe((res) => {
      this.router.navigate(['/signin']);
      this.cookieService.deleteAll();
      localStorage.clear();
      sessionStorage.clear();
    }, error => {
      this.toaster.error('Something went wrong while logout from all devices, Please try again...!');
    });
  }

  onChangeOrganisation() {
    this.matDialog.open(OrganisationSelectorComponent).afterClosed().subscribe((result) => {
      if (result) {
        this.sharedService.currentOrganisation = result;
        this.router.navigate(['permit-app']);
      }
    });
  }

  // opening golden rules dialog
  openGoldenRulesDialog() {
    this.goldenRuleDialog = this.matDialog.open(GoldenRulesComponent, {
      panelClass: 'custom-mat-dialog-container'
    });
  }

}
